import lazyLoading from "./lazyLoading";

export default {
  name: "Order",
  path: "/addorder",
  component: lazyLoading("order/Card"),
  meta: {
    title: "menu.order",
    iconClass: "vuestic-icon vuestic-icon-components",
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/order.js